/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { IconButton, Text, Popover } from '@oneaudi/unified-web-components';
import mapContext from '../../../contexts/map-context';
import { DISPLAY_SIZE } from '../global.style.constants';
import type { UnifiedTheme } from '../../../FeatureApp';

const device = {
  desktop: `(min-width:${DISPLAY_SIZE.DESKTOP})`,
  largeDesktop: `(min-width:${DISPLAY_SIZE.LARGE_DESKTOP})`,
  smallDesktop: `(min-width:${DISPLAY_SIZE.SMALL_DESKTOP})`,
  mobile: `(max-width:${DISPLAY_SIZE.MOBILE})`,
  tablet: `(min-width: ${DISPLAY_SIZE.TABLET})`,
  smallTablet: `(max-width: ${DISPLAY_SIZE.TABLET})`,
};
const Content = styled.div`
  background: ${(props: UnifiedTheme) =>
    process.env.IS_LEGACY ? props.theme.sys.color.canvas.default : 'transparent'};

  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  row-gap: 20px;
  @media ${device.tablet} {
    max-width: 278px;
  }
`;

const Container = styled.div`
  position: relative;
`;

const ButtonStyled = styled(IconButton)`
  margin: 0;
`;

export const LegalDisclaimer = () => {
  const { fiveStarData } = mapContext.useMapState();
  const { legalText } = fiveStarData;
  const legalTextParagraphs = legalText.split(/[\r\n]+|(?<=\.)/);
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  return (
    <Container ref={ref}>
      {ref.current && (
        <Popover
          aria-label="Popover title"
          id="popover_title"
          triggerElement={
            <ButtonStyled
              variant="tertiary"
              icon="info-circle"
              size="sm"
              onClick={() => {
                setOpen(!open);
              }}
            />
          }
          open={open}
          content={
            <Content>
              {legalTextParagraphs.map((line, index) => (
                <Text key={index}>{line}</Text>
              ))}
            </Content>
          }
          onClose={() => {}}
          withTip
        />
      )}
    </Container>
  );
};
